import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CheckedDataService } from '@se/constraint';
import { CpDatasourceService } from 'projects/cp-framework-engine/src/lib/cp-datasource.service';
import { CpNodeService } from 'projects/cp-framework-engine/src/lib/cp-node.service';
import { arrayFunctionsMap } from './custom-functions/arrayFunctions/arrayFunctions';
import { dateFunctionMap } from './custom-functions/dateFunctions/dateFunctions';
import { ClinicalEvalExporter } from './custom-functions/export-clinical-eval/export-clinical-eval';
import { ClinicalEvalExporterParams } from './custom-functions/export-clinical-eval/interfaces';

@Injectable({
    providedIn: 'root',
})
export class CpUcConstraintFunctionsService {
    clinicalEvalExporter?: ClinicalEvalExporter;

    private functionsMap: Record<string, Function> = {};

    init(
        dataService: CheckedDataService,
        nodeService: CpNodeService,
        dataSourceService: CpDatasourceService,
        translateService: TranslateService,
    ) {
        if (this.clinicalEvalExporter) {
            this.clinicalEvalExporter.destroy();
        }
        this.clinicalEvalExporter = new ClinicalEvalExporter(
            dataService,
            dataSourceService,
            nodeService,
            translateService,
        );
        this.clinicalEvalExporter.init();

        this.functionsMap.EXPORTCLINICALEVAL = (params: ClinicalEvalExporterParams) => {
            /*@TODO validare gli input nell'array e dare errore con snackbar??? per ora non serve la funzione non si rompe vengono solo stampate cose non volute*/
            this.clinicalEvalExporter?.setParams(params);
            return this.clinicalEvalExporter?.exportText();
        };

        this.initPureFunctions();
    }

    /**custom function che non hanno necessità di servizi esterni iniettati */
    initPureFunctions() {
        this.functionsMap = {
            ...this.functionsMap,
            ...arrayFunctionsMap,
            ...dateFunctionMap,
        };
    }

    get functionsEntries(): [string, Function][] {
        return Object.entries(this.functionsMap);
    }
}
